import { getHeaders, isTokenExpired, startTokenRefresh } from "../utils/HelperFunctions";
import { showAlert, showUpdationModal } from "./Helpers";

const API_URL = process.env.REACT_APP_API_URL;

const fetchDataWithAuth = async (
  url,
  method = "GET",
  navigate,
  t,
  body = null,
  options = {}
) => {
  try {
    let token = localStorage.getItem("token") || sessionStorage.getItem("token");

    if (!token) {
      return; // Don't show an error (when the user opens the app for the first time)
    }
    // if (isTokenExpired(token)) {
    //   //throw new Error("TokenExpired");
    // }

    // Get headers, but don't include 'Content-Type' if we are sending FormData
    const headers = await getHeaders();

    // Check if the body is FormData; if it is, don't stringify or set Content-Type
    const isFormData = body instanceof FormData;

    const requestOptions = {
      method,
      headers: isFormData ? { ...headers } : { ...headers, 'Content-Type': 'application/json' }, // Only set Content-Type for JSON data
      body: isFormData ? body : body ? JSON.stringify(body) : null,
      ...options,
    };

    // Remove headers if sending FormData, browser will handle them
    if (isFormData) {
      delete requestOptions.headers['Content-Type'];
    }

    // startTokenRefresh();

    const response = await fetch(`${API_URL}${url}`, requestOptions);

    if (!response.ok) {
      if (response.status === 401) {
        navigate("/401");
      }
      const errorText = await response.json();
      if (response.status === 404) {
        showAlert(errorText.message, "warning");
      }
      throw new Error(`${errorText.message}`);
    }

    // Detect if response is a file (CSV or binary)
    const contentType = response.headers.get("Content-Type");

    if (contentType && contentType.includes("text/csv")) {
      // Convert response to blob for download
      const blob = await response.blob();
      const fileName = `${body?.fileName}.csv` || "download.csv";

      const downloadUrl = window.URL.createObjectURL(blob);

      const newTab = window.open(downloadUrl, "_blank", "noopener,noreferrer");

      // Optional: revoke URL after some delay
      setTimeout(() => URL.revokeObjectURL(downloadUrl), 10000);

      // const link = document.createElement("a");
      // link.href = downloadUrl;
      // link.download = fileName;
      // document.body.appendChild(link);
      // link.click();
      // link.remove();
      // window.URL.revokeObjectURL(downloadUrl);

      // Return success status for caller if needed
      return { status: "downloaded", fileName };
    }

    return await response.json();

  } catch (error) {
    if (error.message === "TokenExpired" || error.message === "Unauthorized") {
      localStorage.clear();
      sessionStorage.clear(); // Clear the expired token
      showUpdationModal(t(error.message), "error", navigate, "/");
    }
    else if (error.name === "TypeError" && error.message === "Failed to fetch") {
      localStorage.clear();
      sessionStorage.clear();
      showUpdationModal(t("networkError"), "error");
    } else {
      throw error; // Re-throw the error to be handled by the calling function if needed
    }
  }
};

export default fetchDataWithAuth;
